module.exports = __webpack_public_path__ + "2466f7b0c1cdbbc5bce5bb00920365df.svg";